import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { CHROMECASTING_BANNER_SIZE } from '../../../../common/constants';

const rules = ({ theme, banner }) => ({
  backgroundColor: theme.color.playerBackground,
  backgroundPosition: 'center top',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  bottom: '0',
  left: '0',
  position: 'absolute',
  right: '0',
  top: '0',
  extend: [
    {
      condition: banner,
      style: {
        backgroundImage: `url(${banner}?width=${CHROMECASTING_BANNER_SIZE.width}&height=${CHROMECASTING_BANNER_SIZE.height})`,
      },
    },
  ],
});

const ChromecastBackground = ({ banner }) => {
  const { css } = useFela({ banner });
  return (
    <div className={css(rules)} />
  );
};

ChromecastBackground.propTypes = {
  banner: PropTypes.string,
};

export default React.memo(ChromecastBackground);
